import React from "react";
import { useIntl } from "react-intl";
import { useDialog } from "../components/dialog/useDialog";
import webappPlatformApi from "../webapp-platform-api/webappPlatformApi";

function useErrorAlert() {
  const { formatMessage } = useIntl();
  const { showAlert } = useDialog();

  const showErrorAlert = React.useCallback(
    async (text?: string, locationRefresh?: boolean) => {
      await showAlert({
        title: formatMessage({ id: "common.error_title" }),
        text: text ?? formatMessage({ id: "common.error_text" }),
        confirm:
          locationRefresh === true
            ? async () => {
                if (typeof webappPlatformApi.close === "function") {
                  await webappPlatformApi.close();
                } else {
                  window.location.reload();
                }
              }
            : undefined,
      });
    },
    [showAlert, formatMessage]
  );

  return showErrorAlert;
}

export default useErrorAlert;
